// Utility hooks for AI Studio components

import { useState, useCallback } from 'react';
import useStore from '../Store';

// Hook to check if the viewport is mobile
export const useIsMobile = (): boolean => {
	const isMobile = useStore((state) => state.isMobile);
	return isMobile;
};

// Hook for speech-to-text functionality
export const useSpeechToText = () => {
	const [isListening, setIsListening] = useState(false);
	const [transcript, setTranscript] = useState('');

	// Check if Web Speech API is available
	const speechApiAvailable =
		typeof window !== 'undefined' && ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window);

	const startListening = useCallback((initialPrompt?: string) => {
		setIsListening(true);
	}, []);

	const stopListening = useCallback(() => {
		setIsListening(false);
	}, []);

	return {
		speechApiAvailable,
		isListening,
		transcript,
		startListening,
		stopListening,
	};
};

// Hook to check microphone permissions
export const useMicrophonePermission = () => {
	const [permissionState] = useState<'granted' | 'denied' | 'prompt'>('prompt');
	const [featurePolicyMicrophone] = useState<boolean | undefined>(undefined);

	const requestPermission = useCallback(async () => {
		return false;
	}, []);

	return {
		permissionState,
		featurePolicyMicrophone,
		requestPermission,
	};
};

// Hook to fire user file upload dialog
export const useFireUserFileUpload = () => {
	const fireUserFileUpload = useCallback((callback: (file: File) => void, accept?: string) => {
		const input = document.createElement('input');
		input.type = 'file';
		input.accept = accept || 'image/*';
		input.onchange = (e: any) => {
			const file = e.target.files?.[0];
			if (file) {
				callback(file);
			}
		};
		input.click();
	}, []);

	return fireUserFileUpload;
};

// Export the store
export { default as useAppStore } from '../Store';
